import { Provider } from 'store/api/enums';

function isExcelOrReceiptsProvider(providerName?: string | null): boolean {
  const provider = providerName?.toLowerCase().trim();
  return (
    provider === Provider.EXCEL.toLowerCase() ||
    provider === Provider.RECEIPTS.toLowerCase()
  );
}

/** Document scan / capture entities: all providers except Excel uploads and VAT groups. */
export function entitySupportsDocumentScanning(
  providerName?: string | null
): boolean {
  const provider = providerName?.toLowerCase().trim();
  if (!provider) return false;
  return (
    provider !== Provider.EXCEL.toLowerCase() &&
    provider !== Provider.GROUP.toLowerCase()
  );
}

/** Capture Documents / Transactions tab visibility for an entity. */
export function shouldShowCaptureAndTransactionsTabs(
  providerName?: string | null
): boolean {
  return (
    isExcelOrReceiptsProvider(providerName) ||
    entitySupportsDocumentScanning(providerName)
  );
}

/** Tax Returns promo card for third-party entities (not Excel/Receipts/GROUP). */
export function shouldShowCaptureDocumentsPromo(
  providerName?: string | null
): boolean {
  return entitySupportsDocumentScanning(providerName);
}
